import TEXTBLOCK_CONFIG from './TEXTBLOCK_CONFIG';
import TEXTBLOCK_DEFAULT_DATA from './TEXTBLOCK_DEFAULT_DATA';

export default {
    CONFIG: TEXTBLOCK_CONFIG,
    DEFAULT_DATA: TEXTBLOCK_DEFAULT_DATA
}